"use client";

import * as Dialog from "@radix-ui/react-dialog";
import classNames from "classnames";
import { FC, useRef } from "react";

import { useClickOutside } from "@/hooks";
import { useUIStore } from "@/stores";

import styles from "./modal.module.scss";

const Modal: FC = ({}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const closeModal = useUIStore((state) => state.actions.modal.closeModal);
  const { isOpened, component: ModalBody, data, fullHeight } = useUIStore((state) => state.modal);

  useClickOutside(contentRef, closeModal);

  if (!ModalBody) return null;

  return (
    <Dialog.Root open={isOpened}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} onClick={closeModal} />
        <Dialog.Content
          className={classNames(styles.content, fullHeight && styles.fullHeight)}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <Dialog.Title />
          <Dialog.Description />

          <ModalBody {...data} />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export { Modal };
